import React from 'react';

import Body from './Body';
import Form from './Form';
import Headline from './Headline';
import { LandingPageLayoutProps } from './interfaces';
import styles from './layoutStyles.module.scss';

const Layout = (props: LandingPageLayoutProps): JSX.Element => {
  const { headline, subheadline, pageContentsHtml, ...formProps } = props;

  return (
    <main className="px-16 sm:px-28">
      <div className={styles.landingPageLayout}>
        <Headline headline={headline} subheadline={subheadline} />
        <Body content={pageContentsHtml} />
        <Form {...formProps} />
      </div>
    </main>
  );
};

export default Layout;
